import { render, staticRenderFns } from "./Questionaire.vue?vue&type=template&id=c4248188"
import script from "./Questionaire.vue?vue&type=script&lang=js"
export * from "./Questionaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports